import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { InputAdornment, Stack, TextField, Typography } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeHolder: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
};

export default function RHFTextField({ name,startIcon,
  endIcon,placeHolder,label, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Stack spacing={1}>
          <Typography fontSize={16} color={'text.primary'}> {label}</Typography>
          <TextField
          {...field}
          fullWidth
          placeholder={placeHolder}
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error?.message}
          InputProps={{
            sx: {
              borderRadius: "10px",
              backgroundColor: "background.paper",
              px: { xs: 1, md: 1.3 },
              py: { xs:0, md: 0.5 },
            },
            startAdornment: startIcon ? (
              <InputAdornment position="start">
                {startIcon}
              </InputAdornment>
            ) : null,
            endAdornment: endIcon ? (
              <InputAdornment position="end">
                {endIcon}
              </InputAdornment>
            ) : null,
          }}
          sx={{
            "& input::placeholder": {
              color: "text.secondary",
              opacity: 1,
            },
            "& .MuiOutlinedInput-root": {
              fontSize: { xs: "1.1rem", md: "1rem" },
              "& fieldset": {
                borderColor: "divider",
              },
              "&:hover fieldset": {
                borderColor: "#5E17EB",
                borderWidth: 2,
              },
              "&.Mui-focused fieldset": {
                borderWidth: 2,
                borderColor: "#5E17EB",
              },
            },
          }}
          {...other}
        />
        </Stack>
        
      )}
    />
  );
}
